import React from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../i18n';
import './LanguageSwitcher.css';

const LANGUAGE_OPTIONS = [
  { code: 'tr', labelKey: 'common.turkish', flag: '🇹🇷' },
  { code: 'ru', labelKey: 'common.russian', flag: '🇷🇺' }
];

const LanguageSwitcher = ({ className = '', variant = 'default' }) => {
  const { t, i18n } = useTranslation();

  const handleChange = (event) => {
    const nextLanguage = event.target.value;
    if (SUPPORTED_LANGUAGES.includes(nextLanguage)) {
      i18n.changeLanguage(nextLanguage);
    }
  };

  const handlePillClick = (code) => {
    if (SUPPORTED_LANGUAGES.includes(code)) {
      i18n.changeLanguage(code);
    }
  };

  if (variant === 'login') {
    return (
      <div className={`language-switcher language-switcher--login ${className}`.trim()}>
        <div
          className="language-switcher__pills"
          role="group"
          aria-label={t('common.language')}
        >
          {LANGUAGE_OPTIONS.map(({ code, labelKey, flag }) => {
            const isActive = i18n.language === code;
            return (
              <button
                key={code}
                type="button"
                className={`language-switcher__pill${isActive ? ' active' : ''}`}
                onClick={() => handlePillClick(code)}
                aria-pressed={isActive}
              >
                <span className="language-switcher__flag" aria-hidden="true">{flag}</span>
                <span className="language-switcher__pill-label">{t(labelKey)}</span>
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className={`language-switcher language-switcher--${variant} ${className}`.trim()}>
      <label htmlFor="language-switcher-select" className="language-switcher__label">
        <i className="fas fa-globe" aria-hidden="true"></i>
        <span className="language-switcher__label-text">{t('common.language')}</span>
      </label>
      <select
        id="language-switcher-select"
        className="language-switcher__select"
        value={i18n.language}
        onChange={handleChange}
        aria-label={t('common.language')}
      >
        {LANGUAGE_OPTIONS.map(({ code, labelKey, flag }) => (
          <option key={code} value={code}>
            {flag} {t(labelKey)}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSwitcher;
